<template>
    <div class="grid__container">
        <div class="news">
            <div class="news__back">
                <STBackButton text="Вернуться назад" />
            </div>

            <div v-if="isError"
                 class="news__error">
                <InfoBlock title="Статья не найдена"
                           description="Возможно статья была удалена с сайта!" />
            </div>

            <div v-else-if="news"
                 class="transition-block news__content"
                 :style="{ opacity: animationOpacity, display: animationDisplay}">
                <div
                    v-if="news.type" 
                    class="news__type">
                    {{ news.type }}
                </div>
                <h1
                    class="news__title"
                    v-html="news.title" />
                <h4
                    v-if="news.annotation"
                    class="news__annotation"
                    v-html="news.annotation" />

                <div
                    class="news__body"
                    v-html="news.body" />

                <div
                    v-if="similar.length"
                    class="news__similar">
                    <h2>Читать другие новости</h2>

                    <div class="news__similar-list">
                        <NewsCard
                            v-for="item in computedSimilar"
                            :key="item.id"
                            modify="news-card_theme_similar"
                            :date="item.date"
                            :title="item.title"
                            :link="item.link" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfoBlock from '@/blocks/InfoBlock/InfoBlock';
import {mapActions} from 'vuex';
import NewsCard from '@/blocks/NewsCard/NewsCard';
import Utils from '@/helpers/Utils';

export default {
    name: 'News',

    components: {
        InfoBlock,
        NewsCard
    },

    data() {
        return {
            slug            : null,
            news            : null,
            similar         : [],
            isError         : false,
            animationOpacity: '1',
            animationDisplay: 'block'
        };
    },

    computed: {
        computedSimilar() {
            return Utils.getWindowWidth() < 767 ? this.similar.slice(0, 1) : this.similar;
        }
    },

    watch: {
        /**
         * Метод, который запускается при смене параметра "slug" в URL.
         * @param {Object} to - объект, который содержит информацию о новом маршруте
         * @param {Object} from - объект, который содержит информацию о старом маршруте
         * @returns {Promise<void>}
         */
        async $route(to, from) {
            if (to.params.slug !== from.params.slug) {
                this.slug = to.params.slug;

                this.getNewsData();
                this.startAnimationFade();
            }
        }
    },

    /**
     * Метод, который получает статью по slug, полученному из URL.
     * @function created
     * @async
     * @returns {Promise<void>}
     */
    async created() {
        this.slug = this.$route.params.slug;

        this.getNewsData();
        this.startAnimationFade();
    },

    methods: {
        ...mapActions(['getNewsForSlug']),

        /**
         * Метод, который получает статью по slug, полученному из URL, и присваивает
         * ее в this.news. Если статья не найдена, то this.isError будет true.
         * @async
         * @returns {Promise<void>}
         */
        async getNewsData() {
            try {
                const response = await this.getNewsForSlug(this.slug);
                const data = response.data;

                this.news = data.content;
                this.similar = data.similar;

                if (!this.news) {
                    this.showError();
                }
            } catch (error) {
                this.showError();
                console.error(error);
            }
        },

        showError() {
            this.isError = true;
        },

        startAnimationFade() {
            this.animationDisplay = 'none';
            this.animationOpacity = '0';

            setTimeout(() => {
                this.animationDisplay = 'block';
            }, 50);

            setTimeout(() => {
                this.animationOpacity = '1';
            }, 300);
        }
    }
};
</script>

<style lang="scss">
@import "News";
</style>